export const sectionHeading = {
  fontSize: '14px',
  letterSpacing: '4px',
  color: '#0db3c7',
  display: 'table',
  textTransform: 'uppercase',
  fontWeight: '600',
  margin: '10px 0',
  textAlign: 'center',
}

export const sectionDescription = {
  color: '#040c2c',
  fontSize: '2.6rem',
  fontWeight: '700',
  lineHeight: '1.2',
  letterSpacing: '-2px',
  margin: '10px 0',
  wordSpacing: '4px',
}

export const sectionText = {
  color: '#677294',
  padding: '20px 0',
  marginBottom: '1rem',
  lineHeight: '30px',
  fontSize: '16px',
  fontFamily: 'Open sans, sans-serif',
}
